import { render, staticRenderFns } from "./VisitRegistration.vue?vue&type=template&id=53d862cb&"
import script from "./VisitRegistration.vue?vue&type=script&lang=js&"
export * from "./VisitRegistration.vue?vue&type=script&lang=js&"
import style0 from "./VisitRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VisitRegistration.vue"
export default component.exports